import { render, staticRenderFns } from "./ComplaintDetailGeneral.vue?vue&type=template&id=0206839d"
import script from "./ComplaintDetailGeneral.vue?vue&type=script&lang=js"
export * from "./ComplaintDetailGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports